import { create } from 'zustand';
import type { AuditData } from '../types/audit';

export type SubTab = 'r-executive' | 'r-performance' | 'r-analysis' | 'r-seo' | 'r-market' | 'r-strategy' | 'r-usage';

interface ReportFile {
  id: string;
  filename: string;
  file_size?: number;
}

interface ReportState {
  activeSubTab: SubTab;
  reportData: AuditData | null;
  reportFiles: ReportFile[];
  isExportMode: boolean;
  setSubTab: (tab: SubTab) => void;
  setReportData: (data: AuditData) => void;
  setReportFiles: (files: ReportFile[]) => void;
  setExportMode: (mode: boolean) => void;
  reset: () => void;
}

export const useReportStore = create<ReportState>((set) => ({
  activeSubTab: 'r-executive',
  reportData: null,
  reportFiles: [],
  isExportMode: false,

  setSubTab: (tab) => set({ activeSubTab: tab }),
  setReportData: (data) => set({ reportData: data }),
  setReportFiles: (files) => set({ reportFiles: files }),
  setExportMode: (mode) => set({ isExportMode: mode }),

  reset: () =>
    set({
      activeSubTab: 'r-executive',
      reportData: null,
      reportFiles: [],
      isExportMode: false,
    }),
}));
